import gql from 'graphql-tag'

export const InstitutionFragment = gql`
  fragment InstitutionFragment on Institution {
    __typename
    id
    name
    redirect_uri
  }
`
